import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    shouldComponentUpdate() {
        return false;
    }

    render() {
        const src_prefix = 'https://gfx.tarot.com/images/site/tarot/cosmic-profile/mobile/chinese-';
        const signs = [
            'Rat',
            'Ox',
            'Tiger',
            'Rabbit',
            'Dragon',
            'Snake',
            'Horse',
            'Goat',
            'Monkey',
            'Rooster',
            'Dog',
            'Pig',
        ];

        return (
            <chinese-zodiac-signs>
                <h3>Learn about another sign:</h3>
                <row className='is-wrap'>
                    {signs.map(sign => {
                        return (
                            <column className='is-3 is-4-mobile has-text-center'>
                                <a href={`/astrology/chinese-zodiac/${sign.toLowerCase()}`}>
                                    <img
                                        alt={`Chinese Zodiac Signs: The ${sign}`}
                                        src={`${src_prefix}${sign.toLowerCase()}.svg`}
                                    />
                                </a>
                                <br />
                                <h5 className='has-text-uppercase'>{sign}</h5>
                            </column>
                        );
                    })}
                </row>
            </chinese-zodiac-signs>
        );
    }
}

export default connect()(Component);
